export default __webpack_public_path__ + "static/media/background-new-flip.c60a9de4.png";